exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-wrap[data-v-107d958c]{margin-bottom:10px}.block-wrap .block-hd[data-v-107d958c]{font-size:18px;min-height:55px;line-height:55px;border-bottom:1px solid #ebebeb;margin-bottom:20px}", ""]);

// exports
